import { Static, Type } from '@sinclair/typebox'
import { BaseModelSchema } from '../common/base-model'
import { ApId } from '../common/id-generator'

export type UserProjectId = ApId

export const UserProject = Type.Object({
    ...BaseModelSchema,
    userId: Type.String(),
    projectId: Type.String(),
})

export type UserProject = Static<typeof UserProject>
